import React from "react";

import { dashboardModeAtom, historicalChartMetricAtom } from "@/atoms/store";
import { useAtom, useAtomValue } from "jotai";
import {
  availableHistoricalChartMetrics,
  type HistoricalChartMetric,
} from "@lib/hooks/constants";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@tracify/ui/select";
import { getMetricLabelForDashboardMode } from "@/constants/constants";
import {
  generalMetricsInformation,
  metricsInformation,
} from "@components/MetricNameWithTooltip/metricsInformation";
import { Tooltip, TooltipContent, TooltipTrigger } from "@tracify/ui/tooltip";

function HistoricalChartHeaderSelect({
  disabledMetrics,
}: {
  disabledMetrics?: HistoricalChartMetric[];
}) {
  const [historicalChartMetric, setHistoricalChartMetric] = useAtom(
    historicalChartMetricAtom
  );
  const dashboardMode = useAtomValue(dashboardModeAtom);
  const metricInformation =
    dashboardMode === "general"
      ? generalMetricsInformation
      : metricsInformation;

  const visibleMetrics = disabledMetrics?.length
    ? availableHistoricalChartMetrics.filter(
        (m) => !disabledMetrics.includes(m)
      )
    : availableHistoricalChartMetrics;

  const effectiveMetric = visibleMetrics.includes(historicalChartMetric)
    ? historicalChartMetric
    : visibleMetrics[0];

  return (
    <Select
      defaultValue="total_spend"
      value={effectiveMetric}
      onValueChange={(value) =>
        setHistoricalChartMetric(value as HistoricalChartMetric)
      }
    >
      <Tooltip>
        <TooltipTrigger asChild>
          <SelectTrigger className="w-full focus:ring-0 border-0 shadow-none">
            Historical Chart (<SelectValue placeholder="Select a metric" />)
          </SelectTrigger>
        </TooltipTrigger>
        <TooltipContent className="max-w-sm">
          <div>
            <strong>Historical Trend -</strong>{" "}
            <span
              dangerouslySetInnerHTML={{
                __html:
                  metricInformation[effectiveMetric] ||
                  metricInformation.historical,
              }}
            />
          </div>
        </TooltipContent>
      </Tooltip>
      <SelectContent>
        {visibleMetrics.map((el) => (
          <SelectItem key={el} value={el}>
            {getMetricLabelForDashboardMode(el, dashboardMode)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default HistoricalChartHeaderSelect;
